import { render, staticRenderFns } from "./CsRevisionDetalleSegundoConductor.vue?vue&type=template&id=01413906"
import script from "./CsRevisionDetalleSegundoConductor.vue?vue&type=script&lang=js"
export * from "./CsRevisionDetalleSegundoConductor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports